import Image from '@/components/atoms/Image';
import { Dialog } from '@/components/molecules/Dialog';
import { SocialFederationOptions } from '@/components/molecules/SocialFederationOptions/SocialFederationOptions';
import { AFTER_LOGIN_REDIRECT_KEY } from '@/lib/constants';
import { PropsWithChildren, ReactNode } from 'react';
import { useFullPath } from '@/lib/getFullPath';

export interface AuthDialogProps {
  title: string;
  description: string;
  isAuthDialogOpen: boolean;
  setIsAuthDialogOpen: (isOpen: boolean) => void;
  backGroundImage?: string;
  renderIcon?: ReactNode;
  anchor?: string;
  listingId?: string;
}

export const AuthDialog: React.FC<PropsWithChildren<AuthDialogProps>> = ({
  title,
  description,
  isAuthDialogOpen,
  setIsAuthDialogOpen,
  backGroundImage = null,
  renderIcon,
  anchor,
  listingId,
  children,
}) => {
  const fullPath = useFullPath();

  return (
    <Dialog
      open={isAuthDialogOpen}
      onOpenChange={() => setIsAuthDialogOpen(!isAuthDialogOpen)}
    >
      <div className="flex flex-col gap-l px-[36px] py-3xl">
        {backGroundImage && (
          <div className="flex items-center self-center">
            <div className="h-[80px] w-[80px] rounded-full border-[2px] border-brandMidnight">
              <Image
                src={backGroundImage}
                alt="background image"
                fill
                className="h-full w-full rounded-full object-cover"
              />
            </div>
            {renderIcon && (
              <div className="absolute left-[54%] flex h-[48px] w-[48px] items-center justify-center rounded-full border-[1px] border-neutral-600 bg-white">
                <div className="flex">{renderIcon}</div>
              </div>
            )}
          </div>
        )}
        <div className="self-center">
          <div className="flex w-full justify-center">
            <h3 className="text-h3SemiBold text-brandMidnight">{title}</h3>
          </div>
          <span className="flex text-center text-body1Regular text-neutral-800">
            {description}
          </span>
        </div>
        {children}
        <SocialFederationOptions
          actionType="login"
          handleSignInAction={() => {
            // Check if there's already a redirect URL with an anchor
            const existingRedirect = sessionStorage.getItem(
              AFTER_LOGIN_REDIRECT_KEY
            );

            // If there's an existing redirect with a hash anchor, preserve it
            // Otherwise, set the new redirect URL
            if (!existingRedirect || !existingRedirect.includes('#')) {
              sessionStorage.setItem(
                AFTER_LOGIN_REDIRECT_KEY,
                `${fullPath}${anchor || ''}`
              );
            }

            if (listingId) {
              sessionStorage.setItem('listingId', listingId);
            }
          }}
        />
      </div>
    </Dialog>
  );
};
